angular.module('bmsApp.settings').factory('LicenseDetailSvc', function ($http, $log, $window, $q, CRUDSvc, LICENSE_DETAIL_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(LICENSE_DETAIL_API.INDEX, params);
		},
		read: function(id) {
			return CRUDSvc.get(LICENSE_DETAIL_API.READ + id);
		},
		// create: function (data) {return CRUDSvc.create(LICENSE_DETAIL_API.CREATE, data);},
		update: function (data) {
			return CRUDSvc.create(LICENSE_DETAIL_API.UPDATE, data);
		},
		delete: function (data) {
			return CRUDSvc.delete(LICENSE_DETAIL_API.DELETE, data);
		},
		viewPaymentInfoPreview: function (data) {
			return CRUDSvc.post(LICENSE_DETAIL_API.VIEW_PAYMENT_INFO_TEMPLATE, data);
		},
		saveBookingPrompt: function(params) {
			return CRUDSvc.post(LICENSE_DETAIL_API.SAVE_BOOKING_PROMPT, params);
		},
		saveMinJobValue: function(params) {
			return CRUDSvc.post(LICENSE_DETAIL_API.SAVE_MIN_JOB_VALUE, params);
		},
		addLicenseTermFile: function(params) {
			return CRUDSvc.post('api/settings/licenseDetail/term-file-add', params);
		}

	}

}).constant('LICENSE_DETAIL_API', {
  INDEX: 'api/settings/licenseDetail/index',
  READ: 'api/settings/licenseDetail/read/',
  // CREATE: 'api/settings/licenseDetail/create',
  UPDATE: 'api/settings/licenseDetail/update',
	SAVE_BOOKING_PROMPT: 'api/settings/licenseDetail/save-booking-prompt',
	SAVE_MIN_JOB_VALUE: 'api/settings/licenseDetail/save-min-job-value',
	DELETE: 'api/settings/licenseDetail/delete',
	VIEW_PAYMENT_INFO_TEMPLATE: 'api/settings/licenseDetail/viewTemplatePreview',
});



